import React, { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import Message from '../components/LoadingError/Error';
import Loading from '../components/LoadingError/Loading';
import { createUser } from '../service/UserService';
import Header from '../components/Header';

const Register = ({ user }) => {
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState();

  const navigate = useNavigate();

  useEffect(() => {
    setLoading(false);
  }, []);

  useEffect(() => {
    if (user) {
      navigate('/');
    }
  }, [user]);

  const submitHandler = (e) => {
    e.preventDefault();

    const newUser = {
      name: name,
      email: email,
      password: password,
    };

    createUser(newUser)
      .then((user) => navigate('/login'))
      .catch((error) => setError(error.response.data.message));
  };

  return (
    <>
      <Header searcherDisabled={true} shopLink={true} />
      <div className='container d-flex flex-column justify-content-center align-items-center login-center'>
        {error && <Message variant='alert-danger'>{error}</Message>}
        {loading ? (
          <Loading />
        ) : (
          <form
            className='Login col-md-8 col-lg-4 col-11'
            onSubmit={submitHandler}
          >
            <input
              type='text'
              placeholder='Nombre'
              value={name}
              onChange={(e) => setName(e.target.value)}
            />
            <input
              type='email'
              placeholder='Email'
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />
            <input
              type='password'
              placeholder='Password'
              value={password}
              onChange={(e) => setPassword(e.target.value)}
            />

            <button type='submit'>Registrar</button>
            <p>
              <Link to={'/login'}>
                Ya tengo una cuenta <strong>Acceder</strong>
              </Link>
            </p>
          </form>
        )}
      </div>
    </>
  );
};

export default Register;
